import React, { useState } from "react";
import { Container } from "./component/styled/selfService";
import { useNavigate } from "react-router";
import { useDisableScroll } from "../../hooks/useDisableScroll";
import { HiSparkles } from "react-icons/hi2";
import { FiSearch } from "react-icons/fi";
import { GiCroissant } from "react-icons/gi";
import { PiPlanetFill } from "react-icons/pi";
import ActionCard from "./component/home/actionCard";
import MonotiQrGuideBubble from "./component/home/monotiQrGuideBubble";
import KioskGuideModal from "./component/common/KioskGuideModal";

const SelfService = () => {
  useDisableScroll();
  const navigate = useNavigate();
  const [pendingAction, setPendingAction] = useState(null);

  const actions = [
    {
      name: "keep",
      title: "보관하기",
      Icon: GiCroissant,
      badge: "짐 맡길 때",
      sub: "빵장고에 맡기기",
      helper: "보관함을 고르고 짐을 맡겨주세요",
      desc: "빵을 안전하게 맡기고 편하게 찾아가세요",
      ctaLabel: "맡기기",
      promo: {
        title: "한화생명 이글스파크 픽업 가능",
        desc: "경기 종료 시간에 맞춰 맡기신 짐을 경기장 앞까지 배달해드려요. (야구 경기 있는 날만 가능)",
      },
      disabled: false,
    },
    {
      name: "find",
      title: "찾기",
      Icon: FiSearch,
      badge: "짐 찾을 때",
      sub: "보관함 열기",
      helper: "전화번호와 비밀번호로 빠르게 조회",
      desc: "보관 정보로 빠르게 찾을 수 있어요",
      ctaLabel: "찾기",
      warning: {
        title: "찾기 완료 시 보관이 종료됩니다",
        desc: "찾기 완료시 짐을 모두 꺼내주세요",
      },
      disabled: false,
    },
  ];

  const handleClick = (item) => {
    if (item.disabled) {
      alert("준비 중입니다.");
      return;
    }

    if (item.name === "find") {
      setPendingAction(item);
      return;
    }

    navigate(`/self-service/${item.name}`);
  };

  const handleConfirmFind = () => {
    if (!pendingAction) return;

    const actionName = pendingAction.name;
    setPendingAction(null);
    navigate(`/self-service/${actionName}`);
  };

  return (
    <Container>
      <div className="bgStars" aria-hidden="true">
        <span className="star s1">
          <HiSparkles />
        </span>
        <span className="star s2">
          <HiSparkles />
        </span>
        <span className="star s3">
          <HiSparkles />
        </span>
        <span className="star s4">
          <HiSparkles />
        </span>
        <span className="star s5">
          <HiSparkles />
        </span>
      </div>

      <div className="bgClouds" aria-hidden="true">
        <span className="cloud c1" />
        <span className="cloud c2" />
        <span className="cloud c3" />
      </div>

      <div className="bgDots" aria-hidden="true">
        <span className="dot d1" />
        <span className="dot d2" />
        <span className="dot d3" />
        <span className="dot d4" />
        <span className="dot d5" />
      </div>

      <div className="shell">
        <div className="headerBox">
          <div className="brandRow">
            <div className="brandMain">
              <div className="mascot" aria-hidden="true">
                <span className="mascotIcon">
                  <PiPlanetFill />
                </span>
              </div>

              <div className="brandText">
                <div className="brandEyebrow">KIOSK</div>
                <div className="brandTitle">꿈돌이 빵장고</div>
                <div className="brandSub">원하시는 메뉴를 선택해주세요</div>
              </div>
            </div>

            <div className="brandAside">
              <MonotiQrGuideBubble />
            </div>
          </div>
        </div>

        <div className="contentBox">
          {actions.map((item) => (
            <ActionCard key={item.name} item={item} onClick={handleClick} />
          ))}
        </div>
      </div>

      <KioskGuideModal
        open={pendingAction?.name === "find"}
        title="찾기 전 꼭 확인해주세요"
        description="키오스크에서 찾기를 완료하면 보관이 종료되며, 같은 보관함을 다시 열 수 없습니다."
        imageSrc="/img/selfService/retrieve-warning.png"
        imageAlt="키오스크 찾기 완료 시 보관이 종료되고 다시 열 수 없다는 경고 안내"
        confirmLabel="확인하고 찾기"
        onConfirm={handleConfirmFind}
        variant="warning"
      />
    </Container>
  );
};

export default SelfService;
